<template lang="pug">
  .tabs
    .single-tab(v-for="tab in tabs" :key="tab" v-bind:class="{ active: active == tab }" @click="active = tab;") {{ title_replacer(tab) }}
    .contain-transition(v-bind:style="{ 'height': tab_height }")
      transition(name="fade")
        .tab-content-container(v-if="tabs.length > 0" v-bind:key="active")
          slot.tab-content-item(v-for="tab in tabs" :name="tab" v-if="active == tab")
</template>

<script>
  export default {
    props: ['tabs','start_active'],
    data: function() {
      return {
        active: this.tabs[0],
        tab_height: '755px'
      }
    },
    methods: {
      title_replacer: function(e) {
        return e.replace(/_/g, ' ');
      }
    },
    mounted() {
      this.active = this.start_active;
    }
  }
</script>

<style lang="scss">
  $height: 750px;
  .tab-content-container {
    overflow:hidden;
    overflow-y: scroll;
    max-height:$height;
    transition: height 200ms ease;
    padding-bottom:10px;
    position:absolute;
    z-index:5;
  }
  .contain-transition {
    transition: height 200ms ease;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .tabs {
    .tab-content-container {
      h1.title,h2.title,h3.title,h4.title {
        margin: 14px 0px;
        background:#eee;
        width:100%;
        float:left;
        padding: 20px 0px;
        font-size:16px;
        text-indent:18px;
      }
    }
    .bespoke-documents {
      h4 {
        background-color:#319f66;
        color:#fff;
      }
    }
    .tab-content-container {
      h1.title,h2.title,h3.title,h4.title {
        background:#888;
        color:#eee;
      }
    }
  }

  .tabs {
    p,li {
      margin-bottom:16px;
      line-height:24px;
      font-size:15px;
    }
    li,ul,ol {
      list-style:initial;
    }
    ul li, ol li {
      margin-left:18px;
      margin-bottom:10px;
    }
    ol li {
      list-style-type:decimal;
    }
    .single-tab {
      transition: background 200ms ease;
      color:#fff;
      background:#454545;
      padding:24px 20px;
      display:inline-block;
      margin-right:8px;
      margin-bottom:8px;
      text-transform: uppercase;
      cursor:pointer;
      font-size:15px;
      &:hover,
      &.active {
        background:#14426d;
      }
    }
  }
</style>